import React from 'react';
import SeoTitle from "../Title/SeoTitle";

function Stats(props) {
    return (
        <section className="seo_fact_area sec_pad">
            <div className="home_bubble">
                <div className="bubble b_one"/>
                <div className="bubble b_three"/>
                <div className="bubble b_four"/>
                <div className="bubble b_six"/>
                <div className="triangle b_eight" data-parallax='{"x": 120, "y": -10}'><img src="../../img/seo/triangle_one.png" alt=""/></div>
            </div>
            <div className="container">
                <SeoTitle Title='Over 330+ completed working days & Still counting.'/>
                <div className="seo_fact_info">
                    <div className="seo_fact_item">
                        <div className="text">
                            <div className="counter one">100+</div>
                            <p>Researches<br/>were read</p>
                        </div>
                    </div>
                    <div className="seo_fact_item">
                        <div className="text">
                            <div className="counter two">4</div>
                            <p>Conducted<br/>surveys</p>
                        </div>
                    </div>
                    <div className="seo_fact_item">
                        <div className="text">
                            <div className="counter three">34</div>
                            <p>References</p>
                        </div>
                    </div>
                    <div className="seo_fact_item last">
                        <div className="text">
                            <div className="counter four">30+</div>
                            <p>User<br/>Interfaces</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Stats;
